import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const StoreCard = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background: ${p => p.theme.bg.secondary};
  border-radius: 5px;
  padding: ${layout.spacing.xSmall};
  margin-bottom: ${layout.spacing.small};
  max-width: 600px;
`;

export const StoreInfo = styled.div`
  margin-left: ${layout.spacing.xSmall};
  font-size: ${layout.measurements.fontSizeSmall};
`;
